export enum ApplicationSettings {
  accountingPackage = 'AccountingPackage',
  allocateFullRolls = 'AllocateFullRolls',
  allowBlankDespatchNoteSearch = 'AllowBlankDespatchNoteSearch',
  allowBlankProductSearch = 'AllowBlankProductSearch',
  allowCustomerPortalInvites = 'AllowCustomerPortalInvites',
  allowSupplierProductSearchOption = 'AllowSupplierProductSearchOption',
  autoConfirmOrders = 'AutoConfirmOrders',
  autoCreatePickingListOnConfirm = 'AutoCreatePickingListOnConfirm',
  // How many documents one bulk print may combine (API default 50). Absent = let the
  // server decide; see ApplicationSettingService.getNumber.
  bulkPrintMaxDocuments = 'BulkPrintMaxDocuments',
  // The same for Sales Invoices bulk print - its own cap, so invoices and despatch notes can
  // differ (API default 50, 0 = no cap).
  bulkPrintMaxInvoices = 'BulkPrintMaxInvoices',
  autoLoadEnquiries = 'AutoLoadEnquiries',
  // Label for the customer's own free-text field on the stock item header. Blank
  // (or absent) means the customer does not use it, so the column/field is hidden.
  customerDefinedField = 'CustomerDefinedField',
  customerKey = 'CustomerKey',
  emailCSVFile = 'EmailCSVFile',
  forecastMinimumStockCalculation = 'ForecastMinimumStockCalculation',
  hideExportHeadings = 'HideExportHeadings',
  includeAgentCommissionOnSalesAnalysis = 'IncludeAgentCommissionOnSalesAnalysis',
  invoiceFromPicking = 'InvoiceFromPicking',
  magentoWebsite = 'MagentoWebsite',
  mandatoryOrderSource = 'MandatoryOrderSource',
  overDeliveryPercentageAllowed = 'OverDeliveryPercentageAllowed',
  partDespatchNotAllowed = 'PartDespatchNotAllowed',
  pickByRollWarehouse = 'PickByRollWarehouse',
  printSplitStockLabels = 'PrintSplitStockLabels',
  requirePickListRelease = 'RequirePickListRelease',
  sendCustomsDeclarationsTo = 'SendCustomsDeclarationsTo',
  showLabelSelection = 'ShowLabelSelection',
  /** Off rolls every label print back to the legacy client-rendered templates. */
  useServerRenderedLabels = 'UseServerRenderedLabels',
  showMargin = 'ShowMargin',
  showOrderPosition = 'ShowOrderPosition',
  showPrintOptions = 'ShowPrintOptions',
  showBulkAllocationOption = 'ShowBulkAllocationOption',
  showVatAnalysisOnDocuments = 'ShowVatAnalysisOnDocuments',
  stockProperty1Description = 'StockProperty1Description',
  stockProperty2Description = 'StockProperty2Description',
  stockProperty3Description = 'StockProperty3Description',
  // Months back the Stock Forecasting tab pre-selects and loads on open. Blank, or
  // anything outside 1-12, leaves the tab waiting for Show Details as before.
  stockForecastDefaultMonths = 'StockForecastDefaultMonths',
  summariseBatches = 'SummariseBatches',
  useFulfilmentRoutes = 'UseFulfilmentRoutes',
}
